import { Link } from 'react-router-dom';

export const Footer = ({ className = '' }) => (
  <footer
    className={`border-t border-border px-6 lg:px-12 py-8 ${className}`}
    data-testid="site-footer"
  >
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-[11px] text-muted-foreground">
        © 2026 My Flow Habit, Dr Brandt Gibson, LLC &amp; Dr Brandt R Gibson. All Rights Reserved.
      </p>
      <nav className="flex items-center gap-4 text-[11px] text-muted-foreground" aria-label="Legal">
        <Link to="/terms" className="hover:text-foreground" data-testid="footer-terms-link">Terms</Link>
        <Link to="/privacy" className="hover:text-foreground" data-testid="footer-privacy-link">Privacy</Link>
      </nav>
    </div>
    <div className="max-w-3xl mx-auto text-center space-y-4 text-xs leading-relaxed text-muted-foreground mt-6">
      <p>
        By utilizing this tool, you agree to all of the following: You understand this to be an
        expression of opinions and not professional, medical or legal advice. You are solely
        responsible for the use of any content and hold My Flow Habit, Dr Brandt Gibson LLC, Dr
        Brandt Gibson and all members and affiliates harmless in any event or claim. If you have any
        concerns or questions about the advice given, it is recommended you discuss with a qualified
        business lawyer.
      </p>
      <p>
        If you purchase anything through a link in this tool, you should assume that we have an
        affiliate relationship with the company providing the product or service that you purchase,
        and that we will be paid in some way. We recommend that you do your own independent research
        before purchasing anything.
      </p>
    </div>
  </footer>
);
